import { render, staticRenderFns } from "./PEANotificationListeners.vue?vue&type=template&id=46ddd830&scoped=true"
import script from "./PEANotificationListeners.vue?vue&type=script&lang=js"
export * from "./PEANotificationListeners.vue?vue&type=script&lang=js"
import style0 from "./PEANotificationListeners.vue?vue&type=style&index=0&id=46ddd830&prod&scoped=true&lang=css"
import style1 from "./PEANotificationListeners.vue?vue&type=style&index=1&id=46ddd830&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddd830",
  null
  
)

export default component.exports